import React from "react";

export default function ErrorCard(props) {
    return (
        <div className="flex h-screen">
            <div className="mx-auto my-10">
                <div className="rounded bg-white p-6 text-gray-800 shadow">
                    <div className="flex items-center space-x-4">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-yellow-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                />
                            </svg>
                        </div>
                        <div>
                            {props.title && (
                                <h1 className="mb-1 text-lg font-bold">
                                    {props.title}
                                </h1>
                            )}
                            <div className="prose-sm">{props.children}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
